var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H16C17.886 2 18.828 2 19.414 2.586C20 3.172 20 4.114 20 6V12C20 13.886 20 14.828 19.414 15.414C18.828 16 17.886 16 16 16H9M10 6.5H16M2 17V13C2 12.057 2 11.586 2.293 11.293C2.586 11 3.057 11 4 11H6M2 17H6M2 17V22M6 11V17M6 11H12M6 17V22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5C6 7.03043 5.78929 7.53914 5.41421 7.91421C5.03914 8.28929 4.53043 8.5 4 8.5C3.46957 8.5 2.96086 8.28929 2.58579 7.91421C2.21071 7.53914 2 7.03043 2 6.5C2 5.96957 2.21071 5.46086 2.58579 5.08579C2.96086 4.71071 3.46957 4.5 4 4.5C4.53043 4.5 5.03914 4.71071 5.41421 5.08579C5.78929 5.46086 6 5.96957 6 6.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutor);
export default __webpack_public_path__ + "static/media/tutor.cc10181452903064fef5788266a969e5.svg";
export { ForwardRef as ReactComponent };